<template>
  <div
    class="w-100"
    style="border-bottom-left-radius: 8px; border-bottom-right-radius: 8px"
  >
    <div class="p-3">
      <div class="input-group mb-3">
        <button
          class="btn btn-sm btn-outline-secondary"
          type="button"
          id="button-addon2"
          @click="resetSearch"
        >
          ازنو
        </button>
        <input
          dir="rtl"
          type="text"
          v-model="searchTerm"
          class="form-control small"
          placeholder=""
          aria-describedby="button-addon2"
        />
        <button
          class="btn btn-sm btn-outline-primary"
          type="button"
          id="button-addon2"
          @click="doSearch"
        >
          جستجو
        </button>

      </div>
      <div
        class="d-flex flex-row bd-highlight mt-4" dir="ltr"
        v-if="chart_notes.length != 0"
        style="font-size: 14px"
      >
        <div class="bd-highlight">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item">
                  <select
                    class="page-link"
                    type="button"
                    v-model="sortField"
                    @change="getList()"
                  >
                    <option value="created_at" selected>تاریخ</option>
                    <option value="note_title">عنوان</option>
                  </select>
                </li>
                <li class="page-item">
                  <select
                    class="page-link"
                    type="button"
                    v-model="sortOrder"
                    @change="getList()"
                  >
                    <option value="ASC" style="font-size: 24px">↑</option>
                    <option value="DESC" style="font-size: 24px">↓</option>
                  </select>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="me-auto" style="line-height: 30px; margin-left: 10px">مرتب‌سازی</div>

        <div class="ms-auto bd-highlight">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <li class="page-item">
                <select
                  class="page-link"
                  type="button"
                  v-model="perPage"
                  @change="changePage"
                >
                  <option value="5" selected>5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                </select>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ol
        class="list-group list-group p-0"
        v-if="chart_notes.length != 0"
        dir="rtl"
      >
        <li
          class="list-group-item d-flex justify-content-between align-items-start chart-notes-item"
          v-for="note in chart_notes"
          @click="openNote(note.note_id)"
        >
          <div class="ms-auto me-2">
            <div class="fw-bold">{{ note.note_title }}</div>
            {{ convertToJalali(note.created_at) }}
          </div>
        </li>
      </ol>
      <div class="d-flex flex-row bd-highlight mt-3" dir="ltr">
        <div class="bd-highlight" v-if="chart_notes.length != 0">
          <div class="ms-auto bd-highlight">
            <nav aria-label="Chart note navigation">
              <ul class="pagination pagination-sm justify-content-center">
                <li class="page-item">
                  <button
                    class="page-link"
                    type="button"
                    data-bs-toggle="collapse"
                    href="#new-note-box"
                    role="button"
                    aria-expanded="false"
                    aria-controls="new-note-box"
                    id="new-note-btn"
                    @click="showNewChart"
                  >
                    یادداشت جدید
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="ms-auto bd-highlight" v-if="chart_notes.length != 0">
          <nav aria-label="Chart note navigation">
            <ul class="pagination pagination-sm justify-content-center">
              <!-- Previous page button -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(currentPage - 1)"
                  tabindex="-1"
                  aria-disabled="true"
                  >قبلی</a
                >
              </li>

              <!-- Page numbers -->
              <li
                v-for="pageNumber in displayPages"
                :key="pageNumber"
                class="page-item"
                :class="{ active: pageNumber === currentPage }"
              >
                <a class="page-link" href="#" @click.prevent="changePage(pageNumber)">{{
                  pageNumber
                }}</a>
              </li>

              <!-- Next page button -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)"
                  >بعدی</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div v-if="chart_notes.length == 0">
        <div
          class="p-3"
          style="
            border: 1px solid #ced4da;
            background-color: #f9f9f9;
            direction: rtl;
            text-align: center;
            border-radius: 8px;
          "
        >
          <p class="mb-4">این چارت هیچ یادداشتی ندارد</p>
          <button
            class="btn btn-outline-success mr-auto mx-auto"
            type="button"
            data-bs-toggle="collapse"
            href="#new-note-box"
            role="button"
            aria-expanded="false"
            aria-controls="new-note-box"
          >
            یادداشت جدید
          </button>
        </div>
      </div>
    </div>
    <div
      class="p-2 collapse"
      id="new-note-box"
      style="
        background-color: #f9f9f9;
        border-top: 1px solid #eee;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      "
    >
      <div>
        <input
          class="form-control mb-2"
          type="text"
          placeholder="عنوان یادداشت"
          dir="rtl"
          v-model="noteTitle"
        />

        <div class="justify-content-center text-center w-100">
          <div
            class="mt-2 mr-auto mx-auto"
            role="group"
            aria-label="Basic outlined example"
          >
            <button type="button" class="btn btn-sm btn-success" @click="submitNote">
              ذخیره
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger"
            data-bs-toggle="collapse"
            href="#new-note-box"
            role="button"
            aria-expanded="false"
            aria-controls="new-note-box"
            @click="closeNewNotBox"
            >بستن</button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="show-note-box"
      style="
        background-color: #f9f9f9;
        border-top: 1px solid #eee;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      "
      class="p-3 collapse"
    >
      <div>
        <input
          class="form-control mb-2"
          type="text"
          placeholder="عنوان یادداشت"
          dir="rtl"
          disabled
          v-model="loadedNoteTitle"
        />
        <p
          dir="rtl"
          class="p-2 bg-white"
          style="min-height: 250px; border: 1px solid #ccc; border-radius: 5px"
          v-html="loadedNoteText"
        ></p>

        <div class="justify-content-center text-center w-100">
          <div
            class="mt-2 mr-auto mx-auto"
            role="group"
            aria-label="Basic outlined example"
          >
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              @click="showUpdateNote"
            >
              ویرایش
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              data-bs-toggle="collapse"
              data-bs-target="#delete-note-alert-box"
              aria-expanded="false"
              aria-controls="delete-note-alert-box"
              id="cancel_delete_note"
            >
              حذف
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              data-bs-toggle="collapse"
              data-bs-target="#show-note-box"
              aria-expanded="false"
              aria-controls="show-note-box"
              id="toggleNoteShow"
              @click="closeShowNote"
            >
              بستن
            </button>
            <transition>
              <div
                class="collapse bg-white mt-2"
                id="delete-note-alert-box"
                style="border: 1px solid #ccc; border-radius: 5px"
              >
                <div class="p-4">
                  <p class="text-dark" dir="rtl">
                    آیا یادداشت
                    <span class="text-danger"
                      ><em>{{ this.loadedNoteTitle }}</em></span
                    >
                    حذف شود؟
                  </p>
                  <div class="d-block mt-3">
                    <button
                      class="btn me-auto ms-auto btn-success"
                      @click="deleteNote(id)"
                    >
                      بله
                    </button>
                    <button
                      class="btn me-auto ms-auto btn-danger"
                      @click="cancelNoteDelete"
                    >
                      خیر
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div
      class="collapse p-2"
      style="
        background-color: #f9f9f9;
        border-top: 1px solid #eee;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      "
      id="update-note-box"
    >
      <div>
        <input
          class="form-control mb-2"
          type="text"
          placeholder="ویرایش یادداشت"
          dir="rtl"
          v-model="updatedTitle"
        />

        <div class="justify-content-center text-center w-100">
          <div
            class="mt-2 mr-auto mx-auto"
            role="group"
            aria-label="Basic outlined example"
          >
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="doUpdateNote(id)"
            >
              بروز‌رسانی
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click="closeNoteUpdateBox"
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
    <Loading :is-loading="isLoading" />
  </div>
</template>

<script>
import ApiService from "../service/api";
import moment from "jalali-moment";
import Loading from "./Loading.vue";

export default {
  name: "ChartNoteListPro",
  components: {
    Loading,

  },
  props: ["chart_id", "note_id"],
  data() {
    return {
      isLoading: false,
      id: this.note_id,
      updatedTitle: "",
      updatedEditorData: "",
      loadedNoteTitle: "",
      loadedNoteText: "",
      chart_notes: [],
      noteTitle: "",
      searchTerm: "",
      sortField: "created_at",
      sortOrder: "DESC",
      perPage: 5,
      currentPage: 1,
      totalCharts: 0,
      editor: [],
      editorData: "",
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "|",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "link",
        ],
        language: {
          ui: "en",
          content: "ar",
        },
      },
    };
  },
  mounted() {
    // console.log(this.note_id);
    if (this.note_id) {
      this.getNote();
    }
    this.getList();
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalCharts / this.perPage);
    },
    displayPages() {
      const beforeCurrent = this.currentPage - 5;
      const afterCurrent = this.currentPage + 5;
      const pages = [];

      if (beforeCurrent > 1) {
        pages.push(1);
        if (beforeCurrent > 2) {
          pages.push(null);
        }
      }

      for (let i = beforeCurrent; i <= afterCurrent; i++) {
        if (i > 0 && i <= this.totalPages) {
          pages.push(i);
        }
      }

      if (afterCurrent < this.totalPages) {
        if (afterCurrent < this.totalPages - 1) {
          pages.push(null);
        }
        pages.push(this.totalPages);
      }

      return pages;
    },
  },
  methods: {
    cancelNoteDelete() {
      document.getElementById("cancel_delete_note").click();
    },
    closeNoteUpdateBox() {
      document.getElementById("update-note-box").classList.remove("show");
      this.updatedTitle = "";
      this.updatedEditorData = "";
    },
    closeShowNote() {
      document.getElementById("show-note-box").classList.remove("show");
    },
    doUpdateNote(note_id) {
      const request = {
        hash_id: this.chart_id,
        note_id: note_id,
        note_title: this.updatedTitle,
        note_text: this.updatedEditorData,
      };
      this.isLoading = true
      ApiService.updateNote(request).then((response) => {
        // console.log(response);
        document.getElementById("update-note-box").classList.remove("show");
        document.getElementById("show-note-box").classList.remove("collapsed");
        this.loadedNoteTitle = response["data"]["note_title"];
        this.loadedNoteText = response["data"]["note_text"];
        document.getElementById("show-note-box").classList.add("show");
        this.isLoading = false
        this.getList();
      });
    },
    deleteNote(note_id) {
      const request = {
        hash_id: this.chart_id,
        note_id: note_id,
      };
      this.isLoading = true

      ApiService.deleteNote(request).then((response) => {
        // console.log(response);
        document.getElementById("show-note-box").classList.remove("show");
        document.getElementById("new-note-box").classList.remove("show");
        document.getElementById("delete-note-alert-box").classList.remove("show");
        this.isLoading = false
        this.getList();
      });
    },
    closeNote() {},
    showUpdateNote() {

      document.getElementById("new-note-box").classList.remove("collapsed");
      document.getElementById("show-note-box").classList.remove("show");
      document.getElementById("delete-note-alert-box").classList.remove("collapsed");
      document.getElementById("update-note-box").classList.add("show");

      this.updatedTitle = this.loadedNoteTitle;
      this.updatedEditorData = this.loadedNoteText;
    },
    showNewChart(){
      document.getElementById("show-note-box").classList.remove("show");
      document.getElementById("delete-note-alert-box").classList.remove("collapsed");
      document.getElementById("update-note-box").classList.remove("show");
    },
    closeNewNotBox(){
      this.noteTitle = ''
      this.editorData = ''
    },
    openNote(note_id) {
      const request = {
        hash_id: this.chart_id,
        note_id: note_id,
      };
      this.isLoading = true

      ApiService.getNote(request).then((response) => {
        // console.log(response);

        document.getElementById("new-note-box").classList.remove("show");
        document.getElementById("show-note-box").classList.add("show");
        document.getElementById("delete-note-alert-box").classList.remove("collapsed");

        this.id = note_id;
        this.loadedNoteTitle = response["data"]["note_title"];
        this.loadedNoteText = response["data"]["note_text"];
        this.updatedTitle = ''
        this.isLoading = false
      });
    },
    getNote() {
      const request = {
        hash_id: this.chart_id,
        note_id: this.note_id,
      };
      this.isLoading = true

      ApiService.getNote(request).then((response) => {
        document.getElementById("new-note-box").classList.remove("show");
        document.getElementById("show-note-box").classList.add("show");
        document.getElementById("delete-note-alert-box").classList.remove("collapsed");

        this.id = this.note_id;
        this.loadedNoteTitle = response["data"]["note_title"];
        this.loadedNoteText = response["data"]["note_text"];
        this.isLoading = false
      });
    },
    doSearch() {
      this.getList();
    },
    resetSearch() {
      this.searchTerm = "";
      this.getList();
    },
    submitNote() {
      const params = {
        note_title: this.noteTitle,
        note_text: this.editorData,
        chart_id: this.chart_id,
      };
      this.isLoading = true

      ApiService.saveNote(params).then((response) => {
        this.id = response["data"]["note_id"];
        this.loadedNoteTitle = response["data"]["note_title"];
        this.loadedNoteText = response["data"]["note_text"];
        this.noteTitle = ""
        this.editorData = ""
        document.getElementById("new-note-box").classList.remove("show");
        document.getElementById("show-note-box").classList.remove("collapsed");
        document.getElementById("show-note-box").classList.add("show");
        document.getElementById("delete-note-alert-box").classList.remove("collapsed");
        this.isLoading = false
        this.getList();
      });
    },
    convertToJalali(date) {
      if (date != null)
        return moment.from(date, "en", "YYYY-MM-DD HH:mm").format("HH:mm jYYYY-jMM-jDD");
    },
    getList() {
      const params = {
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        searchTerm: this.searchTerm,
        sortOrder: this.sortOrder,
        sortField: this.sortField,
        currentPage: this.currentPage,
        chart_id: this.chart_id,
      };
      this.isLoading = true
      ApiService.getChartNotes(params).then((response) => {
        this.chart_notes = response["data"]["notes"];
        this.totalCharts = response["data"]["total_charts"];
        this.currentPage = response["data"]["currentPage"];
        this.isLoading = false
      });
    },
    changePerPage(per_page) {
      this.getList();
    },
    changeSortOrder() {
      this.sortOrder = this.sortOrder === "ASC" ? "DESC" : "ASC";
      this.getList();
    },

    searchCharts() {
      this.currentPage = 1;
      this.getList();
    },

    changePage(page) {
      this.currentPage = Number(page);
      this.getList();
    },
  },
};
</script>

<style scoped>
.chart-notes-item:hover{
  cursor: pointer;
  background: #f9f9f9;
}
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
<style scoped>
.note-title {
  font-size: 14px;
}
</style>
